import { useEffect, useState } from "react";

// Returns { days, hours, minutes, seconds, totalMs, isReady }
export function useCountdown(targetIso) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const target = targetIso ? new Date(targetIso).getTime() : 0;
  const diff = target - now;
  const isReady = diff <= 0;
  const clamped = Math.max(diff, 0);

  const days = Math.floor(clamped / (1000 * 60 * 60 * 24));
  const hours = Math.floor((clamped / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((clamped / (1000 * 60)) % 60);
  const seconds = Math.floor((clamped / 1000) % 60);

  return { days, hours, minutes, seconds, totalMs: diff, isReady };
}
